import ScenesColumn from "./components/tableColumn/ScenesColumn";
import AnswerColumn from "./components/tableColumn/AnswerColumn";
import OperateColumn from "./components/tableColumn/OperateColumn";
import UserQuesColumn from "./components/tableColumn/UserQuesColumn";
import StandQuestionColumn from "./components/tableColumn/StandQuestionColumn";
import TranslateColumn from "./components/tableColumn/TranslateColumn";

import i18n from "@/i18n";

export const askLogTable = logType => {
    const columns = [
        {
            colId: "time",
            header: i18n.t("zhiji.robotLog.tabelCloumn.messageTime"),
            type: "Text",
            width: "180px"
        },
        {
            colId: "questionType",
            header: i18n.t("zhiji.robotLog.tabelCloumn.questionType"),
            type: "Text",
        },
        {
            colId: "userQuestion",
            header: i18n.t("zhiji.robotLog.tabelCloumn.quesContent"),
            type: "Custom",
            component: UserQuesColumn
        },
        {
            colId: "questionTranslate",
            header: i18n.t("zhiji.cluster.closeLoop.translateLanguage"),
            type: "Custom",
            component: TranslateColumn
        },
        {
            colId: "scenes",
            header: i18n.t("zhiji.robotLog.tabelCloumn.scenes"),
            type: "Custom",
            component: ScenesColumn
        },
        {
            colId: "standQuestion",
            header: i18n.t("zhiji.robotLog.tabelCloumn.standQuestion"),
            type: "Custom",
            component: StandQuestionColumn
        },
        {
            colId: "questionId",
            header: i18n.t("zhiji.robotLog.tabelCloumn.questionId"),
            type: "Text",
        },
        {
            colId: "answer",
            header: i18n.t("zhiji.robotLog.tabelCloumn.answerContent"),
            type: "Custom",
            component: AnswerColumn
        },
        {
            colId: "indexScore",
            header: i18n.t("zhiji.robotLog.tabelCloumn.matchingFactor"),
            type: "Text",
            tooltip: i18n.t("zhiji.robotLog.tabelCloumn.matchingFactorTip"),
        },
        {
            colId: "recallScore",
            header: i18n.t("zhiji.robotLog.tabelCloumn.recallScore"),
            type: "Text",
            tooltip: i18n.t("zhiji.robotLog.tabelCloumn.recallScoreTip"),
        },
        {
            colId: "operate",
            header: i18n.t("zhiji.common.operate"),
            type: "Custom",
            component: OperateColumn
        }
    ];

    // 踩赞日志
    if (logType === "likeLog") {
        columns.splice(3, 1); // 不显示 中文翻译
        columns.splice(7, 2); // 不显示 匹配系数 召回系数
        // 新增点踩原因
        columns.splice(7, 0, {
            colId: "dislikeReason",
            header: i18n.t("zhiji.robotLog.tabelCloumn.dislikeReason"),
            type: "Text",
        });
    }
    return {
        columns,
        isHideFooter: true,
        pageLength: 10
    };
};

export const answerOptions = () => [
    {
        label: i18n.t("zhiji.robotLog.allAnswer"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.robotLog.noAnswer"),
        value: "noAnswer"
    },
    {
        label: i18n.t("zhiji.robotLog.answered"),
        value: "hasAnswer"
    }
];

export const questionOptions = () => [
    {
        label: i18n.t("zhiji.robotLog.selectType"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.robotLog.byUesr"),
        value: "user"
    },
    {
        label: i18n.t("zhiji.robotLog.byScene"),
        value: "scenes"
    },
    {
        label: i18n.t("zhiji.robotLog.byQuestion"),
        value: "standard"
    },
    {
        label: i18n.t("zhiji.robotLog.byQuestionContent"),
        value: "content"
    },
    {
        label: i18n.t("zhiji.robotLog.byQuestionId"),
        value: "questionId"
    },
    {
        label: i18n.t("zhiji.robotLog.byChatId"),
        value: "chatId"
    }
];

// 全部点踩原因选项
export const clickIdOptions = () => [
    {
        label: i18n.t("zhiji.likedisplay.allStepReason"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.likedisplay.evaluateUnresolved"),
        value: 3,
    },
    {
        label: i18n.t("zhiji.likedisplay.evaluateIrrelevant"),
        value: 7,
    },
    {
        label: i18n.t("zhiji.likedisplay.evaluateDissatisfactionNum"),
        value: 8,
    },
    {
        label: i18n.t("zhiji.likedisplay.evaluateCustomized"),
        value: 9,
    },
];
